/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Anonymized_StatusInputs */



/**
* | output |
* | --- |
* | "This member has been anonymized." |
*
* @param {Member_Anonymized_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const member_anonymized_status = /** @type {((inputs?: Member_Anonymized_StatusInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Anonymized_StatusInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce membre a été anonymisé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este miembro ha sido anonimizado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este membro foi anonimizado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo membro è stato anonimizzato.")
	return /** @type {LocalizedString} */ ("This member has been anonymized.")
});